import cqrsApiService from "../../../shared/services/cqrsApiService.js";

export default {
  fetchAll(vm) {
    return new Promise((resolve, reject) => {
      cqrsApiService.Get("Drilling/CoreBarrels/FindAll", vm).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      });
    });
  },
  delete(vm, id) {
    return new Promise((resolve, reject) => {
      cqrsApiService.Post("Drilling/CoreBarrels/delete", { id }, vm).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      });
    });
  },
  create(vm, domainModel) {
    return new Promise((resolve, reject) => {
      cqrsApiService.Post("Drilling/CoreBarrels/create", { coreBarrel: domainModel }, vm).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      });
    });
  },
  edit(vm, domainModel) {
    return new Promise((resolve, reject) => {
      cqrsApiService.Post("Drilling/CoreBarrels/edit", { coreBarrel: domainModel }, vm).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      });
    });
  }
}